import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { UtilActions, MediaActions, CampaignActions } from '../../_redux';
import AppContext from '../../context';
import PersonalMenu from './PersonalMenu';
import GuestMenu from './GuestMenu';
import PagesMenu from './PagesMenu';
import { CAMPAIGN_TYPES } from '../../constants/campaign';
import intercom from '../../_core/intercom';

const mapStateToProps = state => {
  // const businessDetails
  //  = state.business.get('businessDetails') && state.business.get('businessDetails').toJS()
  // const id = businessDetails && businessDetails.business && businessDetails.business.id
  const businessList = state.business.get('businessList').toJS();
  return {
    user: state.user.get('userMetadata').toJS(),
    // isCurrentBusinessAdmin: (
    //   id && businessList && !!businessList[id]
    // ),
    currentBusiness: state.business.get('businessDetails')
    && state.business.get('businessDetails').toJS().business,
    businessList,
    openMedia: state.media.get('open'),
    listLoading: state.business.get('listLoading'),
    isPersonalMode: !state.general.get('isBusinessMode'),
  };
};

const mapDispatchToProps = {
  OPEN_LOGOUT_DIALOGUE: UtilActions.OPEN_LOGOUT_DIALOGUE,
  SWITCH_USER_MODE: UtilActions.SWITCH_USER_MODE,
  SET_GALLERY_STATE: MediaActions.SET_GALLERY_STATE,
  START_NEW_CAMPAIGN: CampaignActions.START_NEW_CAMPAIGN,
};

class AppMenu extends React.PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    visible: PropTypes.bool,
    openMedia: PropTypes.bool,
    isPersonalMode: PropTypes.bool,
    currentBusiness: PropTypes.object,
    businessList: PropTypes.object,
    history: PropTypes.object.isRequired,
    user: PropTypes.object,
    OPEN_LOGOUT_DIALOGUE: PropTypes.func.isRequired,
    SWITCH_USER_MODE: PropTypes.func.isRequired,
    onMenuClose: PropTypes.func.isRequired,
    SET_GALLERY_STATE: PropTypes.func.isRequired,
    START_NEW_CAMPAIGN: PropTypes.func.isRequired,
  }

  static contextType = AppContext;

  state = {
    isBusinessListOpen: false,
  }

  onBusinessListClick = e => {
    e.preventDefault();
    this.setState({ isBusinessListOpen: !this.state.isBusinessListOpen });
  }

  onImagesClick = () => {
    this.props.SET_GALLERY_STATE({ active: !this.props.openMedia });
    this.props.onMenuClose();
  }

  onSwitchBusinessPersonal = () => {
    this.props.SWITCH_USER_MODE();
    this.props.onMenuClose();
  }

  onLoginClick = () => {
    this.props.onMenuClose();
    this.props.history.replace('/login');
  }

  onStartNewCampaignClick = () => {
    this.props.onMenuClose();
    this.props.START_NEW_CAMPAIGN(CAMPAIGN_TYPES.contentViews);
  }

  onProfileClick = () => {
    this.props.onMenuClose();
    this.props.history.push('/settings/my-profile');
  }

  onBusinessClick = () => {
    const { onMenuClose, history: { push }, currentBusiness } = this.props;
    onMenuClose();
    push(`/page/${currentBusiness.handle || currentBusiness.id}/settings/business-profile`);
  }

  onSupportClick = () => {
    intercom('show');
    this.props.onMenuClose();
  }

  render() {
    const isAuthenticated = this.context.auth.isAuthenticated();
    const {
      user, OPEN_LOGOUT_DIALOGUE, currentBusiness: business,
      businessList, isPersonalMode, isMobile,
    } = this.props;
    const businessesCount = Boolean(Object.keys(businessList).length);
    if (!isAuthenticated) {
      return (
        <GuestMenu
          isMobile={isMobile}
          visible={this.props.visible}
          onMenuClose={this.props.onMenuClose}
          onLoginClick={this.onLoginClick}
        />
      );
    }
    return isPersonalMode ? (
      <PersonalMenu
        isMobile={isMobile}
        isAuthenticated={isAuthenticated}
        visible={this.props.visible}
        user={user}
        onMenuClose={this.props.onMenuClose}
        onSwitchBusinessPersonal={this.onSwitchBusinessPersonal}
        onLoginClick={this.onLoginClick}
        onLogoutClick={OPEN_LOGOUT_DIALOGUE}
        onStartCampaignClick={this.onStartNewCampaignClick}
        onProfileClick={this.onProfileClick}
      />
    ) : (
      <PagesMenu
        isMobile={isMobile}
        isAuthenticated={isAuthenticated}
        visible={this.props.visible}
        business={business}
        businessesCount={businessesCount}
        onMenuClose={this.props.onMenuClose}
        onSwitchBusinessPersonal={this.onSwitchBusinessPersonal}
        onLoginClick={this.onLoginClick}
        onLogoutClick={OPEN_LOGOUT_DIALOGUE}
        isBusinessListOpen={this.state.isBusinessListOpen}
        onBusinessListClick={this.onBusinessListClick}
        onImagesClick={this.onImagesClick}
        onStartCampaignClick={this.onStartNewCampaignClick}
        onBusinessClick={this.onBusinessClick}
        onSupportClick={this.onSupportClick}
      />
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppMenu));
